import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { ReactComponent as TobaccoIcon } from '../../../icons/tobacco.svg';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const HomeScreen = ({ backgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          src={getImageFromS3('images/sms-prl-crt/logo.png')}
          alt="logo-image"
          className={styles.logo}
        />
        <img
          src={getImageFromS3('images/sms-prl-crt/pack.png')}
          alt="pack-image"
          className={styles.pack}
        />
        <p className={styles.packTitle}>
          <b>4</b> мг
        </p>
        <div className={styles.filterCharacteristicContainer}>
          <div className={styles.filterAirPart}>
            <img
              src={getImageFromS3('images/sms-prl-crt/filter-air.png')}
              alt="filter-air"
            />
            <p>Фільтр з повітряною камерою</p>
          </div>
          <p className={styles.filterTitle}>RECESSED 2.0 Filter</p>
          <div className={styles.filterAcetatePart}>
            <p>
              <b>Ацетатна</b> частина
            </p>
            <img
              src={getImageFromS3('images/sms-prl-crt/filter-acetate.png')}
              alt="filter-acetate"
            />
          </div>
          <div className={styles.filterCoalPart}>
            <p>
              <b>Вугільна</b> частина
            </p>
            <img
              src={getImageFromS3('images/sms-prl-crt/filter-coal.png')}
              alt="filter-coal"
            />
          </div>
        </div>
        <div className={styles.formatContainer}>
          <div className={styles.textContainer}>
            <p className={styles.title}>Формат</p>
            <p className={styles.subTitle}>
              Longer than <br></br>King Size<br></br> Slim
            </p>
            <img
              src={getImageFromS3('images/sms-prl-crt/format.png')}
              alt="format"
            />
          </div>
          <img
            src={getImageFromS3('images/sms-prl-crt/format-pack.png')}
            alt="format-pack"
            className={styles.formatPack}
          />
        </div>
        <div className={styles.tobaccoContainer}>
          <p className={styles.title}>
            <b>ТЮТЮНОВА СУМІШ ВІД</b> PARLIAMENT
          </p>
          <div>
            <TobaccoIcon />
          </div>
        </div>
        <div className={styles.buyContainerWrapper}>
          <div className={styles.container}>
            <p className={styles.title}>Де купити?</p>
            <p className={styles.description}>
              <b>Parliament Carat</b> можна знайти у роздрібних точках продажу в
              твоєму місті або на офіційних онлайн сервісах, зокрема:
            </p>
            <div className={styles.buttonContainer}>
              <div>
                <a
                  href="https://rozetka.com.ua/ua/parliament_4823003211770/p49698374/?utm_source=PMUsmsPrlmCarat"
                  target="_blank"
                  onClick={() => sendEvent('rozetka')}
                >
                  Rozetka
                </a>
              </div>
              <div>
                <a
                  href="https://cig-poshta.in.ua/parliament-carat-purple/?utm_source=caratsendoutcda"
                  target="_blank"
                  onClick={() => sendEvent('Cig-Poshta')}
                >
                  Cig-poshta
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prl-crt">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
